"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LuggageType = void 0;
var LuggageType;
(function (LuggageType) {
    LuggageType[LuggageType["CarryOn"] = 0] = "CarryOn";
    LuggageType[LuggageType["Suitcase"] = 1] = "Suitcase";
})(LuggageType || (exports.LuggageType = LuggageType = {}));
//# sourceMappingURL=LuggageType.js.map